import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

import translationES from "./locales/es-ES/translation.json";
import translationEN from "./locales/en-US/translation.json";
import translationPT from "./locales/pt-BR/translation.json";
import translationDE from "./locales/de-DE/translation.json";

const resources = {
  'es-ES': {
    translation: translationES,
  },
  'en-US': {
    translation: translationEN,
  },
  'pt-BR': {
    translation: translationPT,
  },
  'de-DE': {
    translation: translationDE,
  }
};

i18n
    .use(initReactI18next)
    // .use(LanguageDetector)
    .use(Backend)
    .init({
        resources,
        //lng: "pt", // if you're using a language detector, do not define the lng option
        fallbackLng: 'pt-BR',
        interpolation: {
            escapeValue: false,
        },
    });